<template>
    <div>
        <v-card v-if="!readyToLoadListings" class="d-flex justify-center pt-12" flat style="background-color: #EFEFEF">
            <v-progress-circular indeterminate color="primary" class="ma-3 ml-9" size="40" width="3"></v-progress-circular>
        </v-card>

        <div v-if="filteredListings.length" :class="direction == 'vertical' ? `d-block justify-end` : `d-flex d-inline ${filteredListings.length <= 2 ? `justify-space-around` : `justify-space-between`}`"> 
            <div v-if="direction == 'vertical'" class="d-flex d-block pt-5 pb-1 mb-8 ml-8 justify-end hot_header" style="border-bottom:3px solid #0096A6">
                {{ sold_listings ? `Sold Listings` : `Hot Seller Listings` }}
            </div>

            <v-card 
                v-for="item in filteredListings" 
                :key="item.id" 
                elevation="4"
                tile
                :class="direction == 'vertical' ? `mt-0 mr-0 mb-8 ml-8 px-0` : `mt-3 mb-3`">
            
                <router-link :to="`/buyer_listings/${item.listing_id}`" push class="button_link">
                    <v-img class="mx-0 px-0" :height="direction == 'vertical' ? `90` : `100`" :width="direction == 'vertical' ? `` : `260`" :src="item.img">
                        <div class="d-flex flex-column align-end justify-end pa-3 fill-height bottom-gradient">
                            <div class="d-block listing_header">{{ item.listing_id }}</div>
                            <div class="d-block listing_subheader">{{ item.type_name }}</div>
                        </div>
                    </v-img>

                    <div class="d-flex" :style="direction == 'vertical' ? `width: 100%` : `width: 260px`">
                        <div v-if="item.listing_type == 8" alt="COMMISSION" style="height: 74px; width: 50%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                            <div v-if="item.revenue_average_fee_charged == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                            <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue_average_fee_charged | currency(false, false) }}</div>
                            <div class="d-block px-1" style="line-height: 1">Avg Commission</div>
                        </div>
                        <div v-else alt="AUM" style="height: 74px; width: 50%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                            <div v-if="item.aum == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                            <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.aum | currency(false, false) }}</div>
                            <div class="d-block px-1">AUM</div>
                        </div>

                        <div alt="Revenue" style="height: 74px; width: 50%" class="d-flex flex-column align-center justify-center white--text primary text-center">
                            <div v-if="item.revenue == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                            <!-- <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue | currency(false, false)  }}</div> -->
                            <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue }}</div>
                            <div class="d-block px-1">Revenue</div>
                        </div>

                        <!-- <div alt="Potential Buyers" style="height: 74px" :style="item.listing_type == 8 ? 'width: 35%' : 'width: 40%'" class="d-flex flex-column align-center justify-center white--text primary text-center">
                            <div v-if="item.type_name == '[Not Defined]'" class="d-block body-1 font-weight-medium px-1">
                                &mdash;<br>
                                <div class="d-block px-1">Practice Type</div>
                            </div>
                            <div v-else class="d-block body-1 font-weight-medium px-1">{{ item.type_name }}</div>
                        </div> -->

                        <!-- <div v-if="item.listing_type == 8" alt="COMMISSION" style="height: 74px; width: 35%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                            <div v-if="item.revenue_average_fee_charged == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                            <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue_average_fee_charged | currency(false, false) }}</div>
                            <div class="d-block px-1" style="line-height: 1">Avg Commission</div>
                        </div>
                        <div v-else alt="AUM" style="height: 74px; width: 28%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                            <div v-if="item.aum == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                            <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.aum | currency(false, false) }}</div>
                            <div class="d-block px-1">AUM</div>
                        </div>

                        <div alt="Revenue" style="height: 74px;" :style="item.listing_type == 8 ? 'width: 30%' : 'width: 32%'" class="d-flex flex-column align-center justify-center white--text secondary text-center">
                            <div v-if="item.revenue == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                            < !-- <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue | currency(false, false)  }}</div> -- >
                            <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue }}</div>
                            <div class="d-block px-1">Revenue</div>
                        </div>

                        <div alt="Type of Listing" style="height: 74px" :style="item.listing_type == 8 ? 'width: 35%' : 'width: 40%'" class="d-flex flex-column align-center justify-center white--text primary text-center">
                            <div v-if="item.type_name == '[Not Defined]'" class="d-block body-1 font-weight-medium px-1">
                                &mdash;<br>
                                <div class="d-block px-1">Practice Type</div>
                            </div>
                            <div v-else class="d-block body-1 font-weight-medium px-1">{{ item.type_name }}</div>
                        </div> -->
                    </div>
                </router-link>
            </v-card>
        </div>
        
        <div v-else>
            <div v-if="readyToLoadListings" class="text-center py-12" style="width: 100%">
                <div class="d-block py-1">There are no Listings to view at this time, Please check back soon!</div>
                <div class="d-block py-1">In the mean time, make sure you've completed your <router-link :to="`/module_questionnaire/`" push class="button_link primary--text">Buyer Profile</router-link>!</div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import { toDollarsListings } from './utilities';

    export default {
        name: 'DashListings',
        
        props: {
            direction: String,
            authUser: Object
        },

        data () {
            return {
                readyToLoadListings: false,
                listings: [],
                filteredListings: [],
                listing_statuses: [
                    { value: 1, text: 'Active' },
                    { value: 2, text: 'Coming Soon' },
                    { value: 3, text: 'Pending' },
                    { value: 4, text: 'Sold' },
                ],
                states: [],
                buyer_status: [],
                listing_types: [],
                sold_listings: false
            }
        },

        mounted () {
            this.getListings()
        },
        
        methods: {
            getLists: async function () {
                try {
                    let optionsLists = [ 
                        {'name': 'listing_types', 'type': 'int'}, 
                        {'name': 'buyer_status', 'type': 'int'}, 
                        {'name': 'states', 'type': 'txt'}
                    ];
                    
                    const lists_rs = await axios.post(`${appUrls.api}/api/lists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        list_options: optionsLists
                    })
                
                    if(lists_rs.data.outcome){
                        let arrLists = lists_rs.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states') this.states = arrLists[l].list
                            if (arrLists[l].name == 'buyer_status') this.buyer_status = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            getListings: async function () {
                try {
                    const get_lists = await this.getLists()

                    const short_listings = await axios.post(`${appUrls.api}/api/listings`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            user_id: this.authUser.id
                        }
                    })
                
                    if ( short_listings.data.outcome && short_listings.data.listings.length ) {
                        this.listings = short_listings.data.listings;

                        let i = 0;
                        for( let listing of this.listings ) {
                            // this.listings[i].post_date    = dateFormat(listing.post_date, "mm/dd/yyyy");
                            this.listings[i].post_date    = this.listings[i].post_date.substr(0, 10);
                            this.listings[i].listing_type = this.listings[i].listing_type != undefined ? parseInt(this.listings[i].listing_type) : 0;
                            this.listings[i].status       = parseInt(this.listings[i].status);
                            this.listings[i].title        = this.listings[i].title != undefined ? this.listings[i].title : '[No Title]';

                            // LOCATION MODIFICATION
                            let vLoc = ''
                            if (listing.city && listing.state) {
                              vLoc = `${listing.city}, ${listing.state}`
                            }
                            if ((!listing.city && listing.state) || (listing.city && !listing.state)) {
                              vLoc = listing.state || listing.city
                            }
                            this.listings[i].location = vLoc

                            // AUM TEXT
                            if (Number.parseFloat(this.listings[i].aum) >= 1000000) {
                                let aum_text = Number.parseFloat(this.listings[i].aum / 1000000).toFixed(1)
                                this.listings[i].aum_text = '$'+aum_text.replace(/\.?0*$/,'')+'M'
                            }else{
                                this.listings[i].aum_text = toDollarsListings(Number.parseFloat(this.listings[i].aum))
                            }

                            // REVENUE TEXT
                            let rev_text
                            if ( this.listings[i].revenue_t12_months ) {
                                if (Number.parseFloat(this.listings[i].revenue_t12_months) >= 1000000) {
                                    rev_text = Number.parseFloat(this.listings[i].revenue_t12_months / 1000000).toFixed(2)
                                    this.listings[i].revenue = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                                } else {
                                    this.listings[i].revenue = toDollarsListings(Number.parseFloat(this.listings[i].revenue_t12_months))
                                }
                            } else {
                                if (Number.parseFloat(this.listings[i].revenue) >= 1000000) {
                                    rev_text = Number.parseFloat(this.listings[i].revenue / 1000000).toFixed(2)
                                    this.listings[i].revenue = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                                }else{
                                    this.listings[i].revenue = toDollarsListings(Number.parseFloat(this.listings[i].revenue))
                                }
                            }

                            // IMAGE
                            if (this.listings[i].custom_image != null ) {
                                this.listings[i].img = require(`@/assets/listings/custom/${this.listings[i].custom_image}`);
                            } else {
                                this.listings[i].img = require(`@/assets/listings/states/${this.listings[i].state}.jpg`);
                            }

                            // STATUS
                            let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listings[i].status);
                            this.listings[i].status_name = this.listings[i].status != 0 ? statusObj.text : '[Not Defined]';

                            // ACCEPTING APPLICATIONS
                            this.listings[i].accepting_applications = this.listings[i].accepting_flag ? 'Accepting Applications' : 'Not Accepting Applications'

                            // TYPE NAME
                            let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listings[i].listing_type);
                            this.listings[i].type_name = this.listings[i].listing_type != 0 ? typeObj.text : '[Not Defined]';

                            i++;
                        }

                        // SORT LISTINGS STATUS, THEN BY POST_DATE
                        this.listings.sort((a, b) => (a.total_buyers < b.total_buyers) ? 1 : -1 )
                        // this.listings.sort((a, b) => (a.status > b.status) ? 1 : (a.status === b.status) ? ((a.post_date < b.post_date) ? 1 : -1) : -1 )

                        this.filterListingsByStatus( short_listings.data.actions )
                        this.readyToLoadListings = true;
                    }

                } catch (error) {
                    console.log(error);
                }
            },

            filterListingsByStatus: async function ( actions ) {
                // console.log(this.listings)                
                let filtered_interest = []
                filtered_interest = this.listings.filter( listing => {
                    return [1,2].includes(listing.status) && listing.accepting_flag && listing.is_active
                })

                // filtered_interest = []
                if ( !filtered_interest.length ) {
                    filtered_interest = this.listings.filter( listing => {
                        return [4].includes(listing.status) && listing.is_active
                    })
                    filtered_interest.sort((a, b) => (a.aum < b.aum) ? 1 : -1 )
                    this.sold_listings = true
                }

                if ( actions.length ) {
                    filtered_interest = filtered_interest.filter( item => {
                        return actions.find(row => row.listing_id != item.id)
                    })
                }
                
                this.filteredListings = filtered_interest.slice(0, 3);
                this.readyToLoadListings = true;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a.button_link {
        text-decoration-line: none
    }
    .listing_header {
        font-size: 1.25em;
        font-weight: 900;
        color: white;
    }
    .listing_subheader {
        font-size: 1em;
        font-weight: 100;
        color: white;
    }
    .hot_header {
		color: #5F6062;
		font-family: 'Sansation', sans-serif !important;
		font-size: 1.2rem!important;
		font-weight: 400;
		/* letter-spacing: .025em!important; */
		line-height: 1.7rem;
	}
    .bottom-gradient {
        background-image: linear-gradient(to top, rgba(20, 20, 20, 0.56) 46%, transparent 72px);
    }
    
</style>



// WEBPACK FOOTER //
// src/components/DashListings.vue